<template>
    <div class="videoList">
        <div class="nav">
            <ul class="typeBar">
                <li :class="{ active: videoType == '' }" @click="chooseType('')">
                    全部
                </li>
                <li :class="{ active: videoType == '创伤' }" @click="chooseType('创伤')">
                    创伤
                </li>
                <li :class="{ active: videoType == '关节' }" @click="chooseType('关节')">
                    关节
                </li>
                <li :class="{ active: videoType == '脊柱' }" @click="chooseType('脊柱')">
                    脊柱
                </li>
                <li :class="{ active: videoType == '运医' }" @click="chooseType('运医')">
                    运动医学
                </li>
            </ul>
            <div class="sort">
                <span>排序：</span>
                <div :class="{ active: rankType == 'updateTime' }" @click="chooseSort('updateTime')">
                    最新发布
                </div>
                <div :class="{ active: rankType == 'watchNumber' }" @click="chooseSort('watchNumber')">
                    最多播放
                </div>
            </div>
        </div>
        <DataList :dataArray="videoList" @transfer="toDetail" />
        <div v-if="noData">
            <div class="noData flexColum">
                <img src="@/assets/img/none.png" alt="" />
                <p>暂无内容</p>
            </div>
        </div>
        <div class="pageBar" v-if="videoList.length">
            <el-pagination
                background
                layout="prev, pager, next"
                :current-page.sync="pageNum"
                :page-size="20"
                :total="totcalCount"
                @current-change="changePageNum"
            ></el-pagination>
        </div>
    </div>
</template>

<script>
import DataList from "../Common/DataList";

export default {
    name: "VideoList",
    data() {
        return {
            userId: localStorage.getItem("userId") || "",
            pageNum: 1,
            rankType: "updateTime",
            totcalCount: 0,
            videoList: [],
            videoType: "",
            noData:false
        };
    },
    components: { DataList },
    mounted() {
        this.getVideoData("", "updateTime", 1);
    },
    methods: {
        getVideoData(videoType, rankType, pageNum) {
            this.$loading({
                background: "rgba(0, 0, 0, 0.7)",
                text: "拼命加载中"
            });
            let params = {
                category: 2,
                charge: 1,
                keyword: "",
                pageNum: pageNum,
                rank: rankType,
                type: videoType
            };
            this.$axios
                .post("/web/course/queryCourseList", this.$qs.stringify(params))
                .then(res => {
                    let data = res.data;
                    if (data.code == "1") {
                        this.videoList = data.result_data.videoList;
                        this.totcalCount = data.result_data.totalCount;
                        this.noData = data.result_data.videoList.length == 0
                    } else {
                        this.$message.error(data.message);
                    }
                    this.$loading().close();
                })
                .catch(err => {
                    this.$loading().close();
                    this.$message.error(err);
                });
        },
        chooseType(type) {
            this.videoType = type;
            this.pageNum = 1;
            this.getVideoData(type, this.rankType, 1);
            this.addDataBuried(type);
        },
        chooseSort(rank) {
            this.rankType = rank;
            this.pageNum = 1;
            this.getVideoData(this.videoType, rank, 1);
        },
        changePageNum(val) {
            this.pageNum = val;
            this.getVideoData(this.videoType, this.rankType, val);
        },
        toDetail(dic) {
            var gid = dic.gid;
            this.$router.push({ path: "/video/"+gid, params: { gid: gid }});
        },
        addDataBuried(type) {
            let headers = {
                equipmentType: "3", //设备类型： 1：安卓、  2 ：IOS 、 3 ： H5
                phoneModel: "", //手机型号
                appVersionNumber: "" //app版本号
            };
            this.$axios
                .post(
                    "/SD/statistic/addDataBuried",
                    this.$qs.stringify({
                        usergid: this.userId,
                        moduleType: "13",
                        subModuleType: type,
                        locationType: "1",
                        disMobile: "PC"
                    }),
                    {
                        headers
                    }
                )
                .then(res => {});
        }
    }
};
</script>

<style scoped src="../../assets/css/ul-list.css"></style>
<style scoped>

.noData {
    display: flex;
    padding: 100px 0;
}
.noData img {
    width: 300px;
}
.el-pagination.is-background /deep/ .el-pager li:not(.disabled).active{
    background-color: #5680FA;
}
.el-pagination.is-background /deep/ .el-pager li:hover{
    color: #5680FA;
}
.el-pagination.is-background /deep/ .el-pager li:not(.disabled).active:hover{
    color: #ffffff;
}
</style>
